import { useQuery } from 'react-query';

import { request } from 'utils';
import { useConfig } from './config';

export function useQueryTotalBalance(id?: string) {
  const url = '/user/total_balance';
  const { data: config } = useConfig();

  const { data } = useQuery(
    [url, id],
    async () =>
      request
        .get<{
          id?: string;
          total_usd_value: number;
        }>(url, { addr: id! })
        .then(res => ({
          id,
          ...res,
        })),
    {
      enabled: !!id && !config?.level,
      staleTime: 10 * 1000,
      cacheTime: 10 * 1000,
    },
  );

  return data;
}
